module.exports = __webpack_public_path__ + "media/payment/stripe_powered_icon3-46b814f0.svg";